import React from 'react'
import { ModalDialog } from 'chemistry'

export const Dialog = ({ children, setIsOpen, isOpen, finishSurvey }) => {
  return (
    <ModalDialog
      onClose={() => {
        setIsOpen(false)
        finishSurvey()
      }}
      isOpen={isOpen}
      title=''
      showCloseButton
      size='large'
      overlay
      closeOnOverlayClick
      isCentered
      blockScrolling
      modalOverlayProps={{
        backgroundColor: 'rgba(51, 51, 51, .2)'
      }}
      modalContentProps={{
        maxWidth: 'min(1280px,94%)'
      }}
      modalBodyProps={{
        minHeight: '250px',
        display: 'flex',
        paddingBlock: '4rem'
      }}
    >
      {children}
    </ModalDialog>
  )
}
